enum DroneShotIntegrationTypes {
  'Drone Photo' = 'Drone Photo',
  'Drone Video' = 'Drone Video',
  'Video Proof' = 'Video Proof',
  'Photo Proof' = 'Photo Proof',
}

export default DroneShotIntegrationTypes
